import styled from 'styled-components'

export const Container = styled.div`
  /* background-color: ${(props) => props.theme.color.neutral.white}; */
  /* border: 1px solid rgba(73, 73, 73, 0.3); */
  /* border-radius: 0.25rem; */
  padding: 0rem 0.5rem 0rem 1rem;
  display: flex;
  flex-direction: column;
  overflow-x: auto;
  max-height: 70vh;
  align-items: center;
`

export const SelectContainer = styled.div`
  width: 40%;
  max-width: 25rem;
  align-self: end;
  margin-bottom: 2rem;
  display: flex;
  gap: 1rem;
  align-items: center;
`

export const Table = styled.table`
  border-collapse: collapse;
  border-spacing: 30px;
  width: 100%;
  > thead {
    position: sticky;
    top: 0;
    background: #fff;
    > hr {
      width: 100%;
      margin: 0;
    }
  }
  > tbody {
    tr {
      background: #fff;
      border-spacing: 1em 0.5em;
      padding: 0 2em 1em 0;
      border: 3px solid #ffffff;
    }
    tr:nth-child(even) {
      background-color: #d6eeee;
    }
  }
`

export const TableHeader = styled.th`
  padding: 8px;
  text-align: left;
  font-size: ${(props) => props.theme.font.textsm};
  color: ${(props) => props.theme.color.neutral.gray};
  font-weight: 400;
  letter-spacing: 0.00938rem;
`

export const TableCell = styled.td`
  padding: 0.5rem;
  font-size: ${(props) => props.theme.font.textsm};
  background-color: #f5f5f5;
  color: #000;
`

export const TableCellEmpty = styled.td`
  padding: 0.5rem;
  font-size: ${(props) => props.theme.font.textsm};
  background-color: #f5f5f5;
  color: #000;
  text-align: center;
`

interface StatusBoxProps {
  status: string
}

export const StatusBox = styled.div<StatusBoxProps>`
  color: ${(props) => props.theme.color.neutral.white};
  background-color: ${(props) =>
    props.status === 'Em ocorrência'
      ? props.theme.color.red.red600
      : props.status === 'Fechado'
      ? props.theme.color.green.green
      : props.theme.color.purple.purple600};
  padding: 0.5rem;
  border-radius: ${(props) => props.theme.border.radius};
  text-align: center;
  font-size: ${(props) => props.theme.font.textcaption};
  white-space: nowrap;
  cursor: default;
`
